import React from "react";
import { ContainerPane } from "@components/organisms/container-pane/container-pane";
import { Spacer16 } from "@components/atoms/spacer-16/spacer-16";

import { useDispatch } from "react-redux";
import { updateModalsCloseDrawerModal } from "@src/reducers/your-reducer";
import { ButtonWithIcon } from "@src/components/atoms/buttons/button-with-icon/button-with-icon";
import styles from "./no-gateways-detected-view.module.scss";
import { HintTitle } from "@src/components/atoms/hint-title/hint-title";
import { Title } from "@src/components/atoms/title/title";
import gatewayDarkBlueIcon from "@src/assets/svg/gateway-dark-blue-icon.svg";
import { useI18N } from "@src/language/language-context";

const cssClassName = "no-gateways-detected-view";

export const NoGatewaysDetectedView = () => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const texts = {
    noGatewaysDetectedSubtitle: i18n(
      "modules.noGatewaysDetectedView.noGatewaysDetectedSubtitle",
    ),
    noGatewaysConnectedHint: i18n(
      "modules.noGatewaysDetectedView.noGatewaysConnectedHint",
    ),
    noGatewaysDetectedTitle: i18n(
      "modules.noGatewaysDetectedView.noGatewaysDetectedTitle",
    ),
    noGatewaysDetectedButtonText: i18n(
      "modules.noGatewaysDetectedView.noGatewaysDetectedButtonText",
    ),
    noGatewaysDetectedQuestion: i18n(
      "modules.noGatewaysDetectedView.noGatewaysDetectedQuestion",
    ),
    noGatewaysDetectedAnswer: i18n(
      "modules.noGatewaysDetectedView.noGatewaysDetectedAnswer",
    ),
    noGatewaysDetectedUploadButtonText: i18n(
      "modules.noGatewaysDetectedView.noGatewaysDetectedUploadButtonText",
    ),
    noGatewaysDetectedLearnMoreButtonText: i18n(
      "modules.noGatewaysDetectedView.noGatewaysDetectedLearnMoreButtonText",
    ),
  };

  const addGatewayManuallyClickHandler = (e) => {
    e.preventDefault();
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: "addNewGatewayDrawerModal",
      }),
    );
  };

  return (
    <ContainerPane>
      <div className={styles[`${cssClassName}__content-container`]}>
        <HintTitle text={texts.noGatewaysConnectedHint} />
        <div className={styles[`${cssClassName}__title-wrapper`]}>
          <Title text={texts.noGatewaysDetectedTitle} />
        </div>
        <Spacer16 />
        <Spacer16 />
        <ButtonWithIcon
          fun={addGatewayManuallyClickHandler}
          icon={gatewayDarkBlueIcon}
          text={texts.noGatewaysDetectedButtonText}
        />
        <Spacer16 />
        <Spacer16 />
      </div>
    </ContainerPane>
  );
};
